import React, { useState } from "react";
import "./MultipleServiceAccordion.css";

const MultipleServiceAccordion = (props) => {
  const [openIndex, setOpenIndex] = useState(null); // State to manage the open section index

  const toggleCollapse = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle the collapse state
  };

  return (
    <div>
      <div className="container section-title" data-aos="fade-up">
        <h2 style={{ margin: "5px" }}> {props?.serviceHeader}</h2>
        <p>
          <b>{props?.description}</b>
        </p>
      </div>
      <div className="text-center mb-3">
        {props?.sections.map((section, index) => (
          <div key={section.id} className="accordion-item">
            <button
              className={`btn mx-2 ${
                openIndex === index ? "btn-success" : "btn-primary"
              }`} // Change button color based on active state
            
              type="button"
              onClick={() => toggleCollapse(index)}
              aria-expanded={openIndex === index}
              style={{ margin: "3px", width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}
              aria-controls={`collapseExample${section.id}`}
            >
              <span>{section.name}</span>
              <span className="arrow">
                {openIndex === index ? "▲" : "▼"}
              </span>
            </button>
            <div
              className={`collapse ${openIndex === index ? "show" : ""}`}
              id={`collapseExample${section.id}`}
            >
              <div className="card card-body">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <p>{section?.content}</p>
                  </div>
                  <div className="col-md-4">
                    <center>
                      <img
                        src={section?.imgSrc}
                        alt={section?.imgAlt}
                        className="img-fluid"
                        style={{ maxWidth: "auto", height: "50%" }}
                      />
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultipleServiceAccordion;